<template>
  <v-dialog v-model="dialog" scrollable persistent max-width="800px" transition="dialog-transition">
    <v-card>
      <v-card-title>
        Atendimento {{ tiposAtendimentos[tipoAtendimento] }}
        <v-icon class="close" @click="$emit('update:dialog', false)">mdi-close</v-icon>
      </v-card-title>
      <v-stepper v-if="!showSuccess" v-model="stepper" :loading="loading">
        <v-stepper-header>
          <v-stepper-step :complete="stepper > 1" step="1">
            Confirme seus dados:
          </v-stepper-step>
          <v-stepper-step :complete="stepper > 2" step="2">
            Dia do atendimento:
          </v-stepper-step>
          <v-stepper-step :complete="stepper > 3" step="3">
            Escolha o horário:
          </v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <UserDataStep @update-step="updateStep" @close="$emit('update:dialog', false)" />
          </v-stepper-content>
          <v-stepper-content step="2" class="justify-center text-center mx-auto">
            <SelectDateStep @update-step="updateStep" @on-change-date="onChangeDate"
              :tipoAtendimento="tipoAtendimento" />
          </v-stepper-content>
          <v-stepper-content step="3">
            <SelectHorarioStep @update-step="updateStep" :medicosHorarios="medicoHorarios"
              :selectedHorario.sync="selectedHorario" :date="selectedDate" @on-submit="onSubmit" />
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
      <v-card-text v-else class="justify-center align-center text-center">
        <div class="title mt-5">
          Recebemos a solicitação do seu agendamento, em breve você receberá a confirmação.
        </div>
        <v-icon color="success" size="64">mdi-check-circle</v-icon>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import UserDataStep from './UserDataStep.vue'
import SelectDateStep from './SelectDateStep.vue'
import SelectHorarioStep from './SelectHorarioStep.vue'
import ambulatorioDigitalService from '@/services/ambulatorioDigital'

export default {
  props: {
    id: {
      type: String
    },
    dialog: {
      required: true,
      type: Boolean
    },
    tipoAtendimento: {
      required: true,
      type: String
    }
  },
  components: {
    UserDataStep,
    SelectDateStep,
    SelectHorarioStep
  },
  data() {
    return {
      tiposAtendimentos: {
        clinico: 'Clínico',
        nutricional: 'Nutricional',
        psicologico: 'Psicológico'
      },
      stepper: 1,
      picker: null,
      loading: false,
      loadingUpdate: false,
      selectedDate: null,
      medicoHorarios: null,
      selectedHorario: null,
      showSuccess: false,
      atendimento: null
    }
  },
  methods: {
    onChangeDate({ data, medicoHorarios }) {
      this.selectedHorario = null
      this.selectedDate = data
      this.medicoHorarios = medicoHorarios
    },
    updateStep(step) {
      this.stepper = step
    },
    async onSubmit() {
      if (this.id) {
        this.updateAtendimentoAmbulatorial()
      } else {
        this.createAtendimentoAmbulatorial()
      }
    },
    async createAtendimentoAmbulatorial() {
      try {
        this.$showLoading()
        const params = {
          idHorario: this.selectedHorario,
          tipo: this.tipoAtendimento
        }
        await ambulatorioDigitalService.createAmbulatorio(params)
        this.showSuccess = true
      } catch (error) {
        console.error(error)
        this.$showErrorMessage(error.response.data.message)
      } finally {
        this.$hideLoading()
      }
    },
    async updateAtendimentoAmbulatorial() {
      try {
        this.$showLoading()
        const params = {
          idAtendimento: this.id,
          idHorario: this.selectedHorario,
          tipo: this.tipoAtendimento
        }
        await ambulatorioDigitalService.updateAmbulatorio(params)
        this.showSuccess = true
        this.$emit('on-update-agendamento')
      } catch (error) {
        console.error(error)
        this.$showErrorMessage(error.response.data.message)
      } finally {
        this.$hideLoading()
      }
    },
    async getAgendamento() {
      try {
        this.$showLoading()
        const { data } = await ambulatorioDigitalService.getAgendamento(this.id)
        this.horario = data.horario_ambulatorial_inicio
      } catch (error) {
        console.error(error)
        this.$showErrorMessage(error.response.data.message)
      } finally {
        this.$hideLoading()
      }
    }
  },
  mounted() {
    if (this.id) {
      this.getAgendamento()
    }
  },
}

</script>
<style>
.form-dados {
  overflow-y: scroll;
}

.close {
  margin-left: auto;
}
</style>